import { useEffect, useState } from 'react';

// Indicador de FPS para diagnóstico de rendimiento.
// Se activa agregando ?debug=fps a la URL.
export default function FpsMeter() {
  const [fps, setFps] = useState(0);

  useEffect(() => {
    let frames = 0;
    let last = performance.now();
    let raf;

    const tick = (now) => {
      frames++;
      if (now - last >= 1000) {
        setFps(Math.round((frames * 1000) / (now - last)));
        frames = 0;
        last = now;
      }
      raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  const color = fps < 30 ? '#f87171' : fps < 50 ? '#fbbf24' : '#4ade80';

  return (
    <div
      style={{
        position: 'fixed',
        top: 4,
        right: 4,
        zIndex: 9999,
        background: 'rgba(0,0,0,0.75)',
        color,
        padding: '2px 6px',
        fontSize: 11,
        fontFamily: 'monospace',
        borderRadius: 4,
        pointerEvents: 'none',
      }}
    >
      {fps} fps
    </div>
  );
}
